module.exports = __webpack_public_path__ + "static/media/15.7a325425.ogg";